import React from 'react';
import style from './CurrentFairValue.module.css';
import UpsideBadge from '../UpsideBadge/UpsideBadge';

const CurrentFairValue = ({ discounted_cash_flows, price, stock }) => {
  if (discounted_cash_flows === null || discounted_cash_flows.dcf === null) {
    return null;
  }

  const dcf = parseFloat(discounted_cash_flows.dcf) || 0;
  const priceToday = price || 0;

  const change = dcf !== 0 ? ((dcf / priceToday) * 100 - 100).toFixed(1) : 0;

  return (
    <div className={style.container}>
      <span className={style.price}>${dcf.toFixed(2)}</span>
      <h3 className={style.headline}>Current Fair Value</h3>
      <UpsideBadge change={change} />
      <p className={style.text}>
        {change > 0 ? 'Undervalued' : 'Overvalued'} by {Math.abs(change)}% based on the{' '}
        {stock?.symbol ? (
          <a className={style.link} href={`/stocks/${stock.symbol.toLowerCase()}/discounted-cash-flow`}>
            discounted cash flow analysis
          </a>
        ) : (
          'discounted cash flow analysis'
        )}.
      </p>
    </div>
  );
};

export default CurrentFairValue;